import React from 'react'
import PropTypes from 'prop-types'
import { navigate } from '@reach/router'
import { graphql, useStaticQuery } from 'gatsby'
import {
  Box,
  TextField,
  MenuItem,
  makeStyles,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { filterByNodeLocale } from '../utils/i18n-helpers'

const useStyles = makeStyles(() => ({
  paper: {
    maxHeight: '60vh',
  },
}))

const BlogCategorySelect = ({ active }) => {
  const {
    allContentfulCategory: { nodes = [] },
    allContentfulBlog: { distinct = [] },
  } = useStaticQuery(graphql`
    query {
      allContentfulCategory {
        nodes {
          name
          node_locale
          relativePath
          contentful_id
        }
      }

      allContentfulBlog {
        distinct(field: categories___contentful_id)
      }
    }
  `)

  const { t } = useTranslation('labels')
  const classes = useStyles()
  const categories = nodes
    .filter(filterByNodeLocale)
    .filter((item) => distinct.includes(item.contentful_id))

  return (
    <Box mb={2}>
      <TextField
        id="category"
        fullWidth
        select
        variant="outlined"
        label={t('selectCategory')}
        value={active}
        SelectProps={{
          MenuProps: {
            classes: { paper: classes.paper },
          },
        }}
      >
        <MenuItem onClick={() => navigate(t('blogPath'))}>
          {t('all')}
        </MenuItem>
        {categories.map((x) => (
          <MenuItem
            key={x.relativePath}
            value={x.relativePath}
            onClick={() => navigate(x.relativePath)}
          >
            {x.name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}

BlogCategorySelect.defaultProps = {
  active: undefined,
}

BlogCategorySelect.propTypes = {
  active: PropTypes.string,
}

export default BlogCategorySelect
